<div class="nsc-app-header" #fullSection role="banner" [class.nsc-app-header--dark]="show.darkHeader" [class.nsc-app-header--light]="!show.darkHeader"
  [style.background-color]="content.headerBackgroundColor">
  <a id="skip_link" #skipLink href="#middleSection" class="nsc-skipLink" (click)="$event.preventDefault(); clickSkipToMainContent()">Skip to main content</a>
  <div  class="container" >
    <span id="header_help_desc" class="cdk-visually-hidden" aria-hidden="true">opens in new window</span>
    <!-- mobile header; -->
    <div class="row align-items-center nsc-app-header__row--sm">
      <div class="col-12">
        <h1  class="nsc-app-header__title ">
          Transcript Ordering Center
        </h1>
      </div>
    </div>
    <div class="row nsc-app-header__row--sm">
      <div class="col-12">
        <!-- new column so we can adjust the gutters between columns, but still line up with the row above; -->
        <div class="row nsc-row--12 align-items-center">
          <div class="col">
            <!-- new row so the content will only be as wide as the content; -->
            <!-- the parent col needs to stretch the whole width, so the info link and cart are right aligned; -->
            <div class="row nsc-row--12 align-items-center">
              <div class="col-auto">
                @if (!content.schoolLogoSrc) {
                  <img src="/assets/Nsc-Tree-Logo.svg"
                    alt="National Student Clearinghouse logo"
                    class="nsc-app-header__logo--nsc" />
                }
                @if (content.schoolName) {
                  <span class="mat-caption nsc-app-header__school-name">{{ content.schoolName
                  }}</span>
                }
                @if (content.schoolLogoSrc) {
                  <img src="{{ content.schoolLogoSrc }}"
                    [attr.alt]="content.schoolLogoAlt ? content.schoolLogoAlt + ' logo' : 'School logo'"
                    class="nsc-app-header__logo--school" />
                }
              </div>
            </div>
          </div>

          @if (content.headerHelpHyperlink) {
          <div class="col-auto">
            <div class="nsc-app-header__help">
              <mat-icon class="nsc-app-header__icon" aria-hidden="true">help_outline</mat-icon>
              <a [href]="content.headerHelpHyperlink" rel="noopener" target="_blank" aria-describedby="header_help_desc">
                <span class="mat-caption">Help</span>
              </a>
            </div>
          </div>
          }

          @if (show.cart) {
            <div class="col-auto">
              <div class="nsc-app-header__cart">
                <button [disabled]="isCartDisabled"
                  [class.nsc-app-header__cart-disabled]="isCartDisabled"
                  class="nsc-app-header__cart-content nsc-app-header__cart-content--button"
                  [attr.aria-label]="'Shopping cart, ' + content.shoppingCartCount + (content.shoppingCartCount === 1 ? ' transcript order' : ' transcript orders')"
                  (click)="goToOrderReview()">
                  <mat-icon class="nsc-app-header__icon" aria-hidden="true">shopping_cart</mat-icon>
                  <strong class="nsc-app-header__cart-count mat-caption" aria-hidden="true">{{ content.shoppingCartCount }}</strong>
                </button>
              </div>
            </div>
          }
      </div>
    </div>
  </div>

  <!-- desktop header; -->
  <div class="row nsc-app-header__row--md">

    <div class="col-12">
      <div class="row nsc-row--12 align-items-center">
        <div class="col">
          <div>
            <h1 class="nsc-app-header__title ">Transcript
            Ordering Center</h1>
          </div>
        </div>

        <div class="col-auto">
          @if (!content.schoolLogoSrc) {
            <img src="/assets/Nsc-Tree-Logo.svg"
              alt="National Student Clearinghouse logo"
              class="nsc-app-header__logo--nsc"/>
          }
          @if (content.schoolName) {
            <span class=" nsc-app-header__school-name">{{ content.schoolName
            }}</span>
          }
          @if (content.schoolLogoSrc) {
            <img src="{{ content.schoolLogoSrc }}"
              [attr.alt]="content.schoolLogoAlt ? content.schoolLogoAlt + ' logo' : 'School logo'"
              class="nsc-app-header__logo--school" />
          }
        </div>

        @if (content.headerHelpHyperlink) {
        <div class="col-auto">
          <div class="nsc-app-header__help">
            <mat-icon class="nsc-app-header__icon" aria-hidden="true">help_outline</mat-icon>
            <a [href]="content.headerHelpHyperlink" rel="noopener" target="_blank" aria-describedby="header_help_desc">
              <span class="mat-caption">Help</span>
            </a>
          </div>
        </div>
        }

        @if (show.cart) {
          <div class="col-auto">
            <div class="nsc-app-header__cart">
              <button [disabled]="isCartDisabled"
                [class.nsc-app-header__cart-disabled]="isCartDisabled"
                class="nsc-app-header__cart-content nsc-app-header__cart-content--button"
                [attr.aria-label]="'Shopping cart, ' + content.shoppingCartCount + (content.shoppingCartCount === 1 ? ' transcript order' : ' transcript orders')"
                (click)="goToOrderReview()">
                <mat-icon class="nsc-app-header__icon" aria-hidden="true">shopping_cart</mat-icon>
                <strong class="nsc-app-header__cart-count mat-caption" aria-hidden="true">{{ content.shoppingCartCount }}</strong>
              </button>
            </div>
          </div>
        }
    </div>
  </div>
</div>
</div>
<div class="nsc-app-header__band"></div>
</div>